import React from 'react'
import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { useMomentStory } from '@/contexts/MomentStoryContext'
import { MomentStoryPlayerHeader } from '@/organisms/CollectibleSceneInfo/EngagementDetailOverlay/MomentStoryPlayerHeader'
import { MomentStoryPlayer } from '@/organisms/StoryPlayer'
import { PlayableStory } from '@/utils/StoryUtil'

interface MomentStoryModalProps {
  onClose: () => void
  story?: PlayableStory
}

export const MomentStoryModal: React.FC<MomentStoryModalProps> = ({ onClose }) => {
  const { story } = useMomentStory()

  const userName = story?.userName
  const projectName = story?.projectName ?? 'Angel'

  if (!story) return null

  return (
    <div className="fixed left-0 top-0 z-[100] h-full w-full">
      <div className="relative h-full w-full">
        <div className="absolute left-0 top-0 h-full w-full bg-black/[75%]" />
        <div className="absolute left-0 top-0 h-full w-full overflow-hidden px-5 py-4 sm:pt-14">
          <div className="flex items-center justify-center">
            <div className="flex h-full w-full flex-col gap-y-2 sm:w-3/4 md:w-1/2 lg:w-4/12 xl:w-4/12 2xl:w-3/12">
              <Button variant="plain" className="self-end" onClick={onClose}>
                <CloseIcon className="cursor-pointer" size={24} color="white" />
              </Button>
              <MomentStoryPlayerHeader userName={userName} story={story} projectName={projectName} />
              <div className="mt-2">
                <MomentStoryPlayer story={story} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
